module.exports = __webpack_public_path__ + "img/Fondo_movil_optimo.a99ac8ee.svg";